import { Injectable } from "@angular/core";


@Injectable({
  providedIn: 'root'
})
export class SecureTokenService {
  private static readonly LOGOUT_MARKER = 'explicitLogout';
  private static accessToken: string | null = null;
  private static refreshToken: string | null = null;
  private static tokenExpiry: Date | null = null;

  static async storeTokens(accessToken: string, refreshToken?: string, expiresIn?: number): Promise<void> {
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    
    if (expiresIn) {
      this.tokenExpiry = new Date(Date.now() + (expiresIn * 1000));
    }
  }

  static getAccessToken(): string | null {
    // SECURITY: Tokens are stored in memory only, never in plaintext sessionStorage
    // to prevent exposure in browser history, developer tools, or storage inspection.
    // Token availability is limited to the current session and is cleared on logout.
    
    // Check if token is expired
    if (this.tokenExpiry && new Date() >= this.tokenExpiry) {
      this.clearTokens();
      return null;
    }

    return this.accessToken;
  }

  static getRefreshToken(): string | null {
    return this.refreshToken;
  }

  static clearTokens(): void {
    this.accessToken = null;
    this.refreshToken = null;
    this.tokenExpiry = null;
  }

  static markLoggedOut(): void {
    sessionStorage.setItem(this.LOGOUT_MARKER, 'true');
  }

  static clearLogoutMarker(): void {
    sessionStorage.removeItem(this.LOGOUT_MARKER);
  }

  static wasExplicitlyLoggedOut(): boolean {
    return sessionStorage.getItem(this.LOGOUT_MARKER) === 'true';
  }
}